import { applicationActions } from "../reducer";

import { Data } from '../reducer/setNotice';
import { NOTICE_TYPES } from '../../constants';

export const setErrorNotice = (
  data?: Data
) => applicationActions.setNotice({ data, type: NOTICE_TYPES.error });
